import { useMemo } from 'react';
import { useOrganizationStore } from '../stores/useOrganizationStore';
import { hasAnyConnectedCrm } from '../utils/rollout';

/**
 * Returns true if the organization has an active CRM integration
 * (FUB direct connection OR any Rollout CRM connected — handles both the
 * new `credentials[]` and legacy `<crm>.connected` shapes).
 * When true, the Upload Database button should be hidden.
 */
export function useHasIntegration(): boolean {
  const organization = useOrganizationStore((s) => s.organization);

  return useMemo(() => {
    // FUB direct (non-Rollout) connection
    if (
      organization?.connected_crm === 'followupboss' ||
      Boolean(organization?.fubSetup?.allowedStages?.length)
    ) {
      return true;
    }
    return hasAnyConnectedCrm({
      crmConnections: organization?.crmConnections,
      rollout: organization?.rollout,
    });
  }, [
    organization?.connected_crm,
    organization?.fubSetup?.allowedStages,
    organization?.crmConnections,
    organization?.rollout,
  ]);
}
